<template>
	<div
		v-html="SVG"
		class="geometry-svg"
	/>
</template>
<script>
import { geoJson2SVG } from '@/helpers/utilsHelper'
import { computed } from 'vue'

export default {
	props: {
		feature: {
			type: Object,
			default: () => ({})
		},

		fillColor: {
			type: String,
			default: '#BFE7CD'
		},

		strokeColor: {
			type: String,
			default: '#3D8A76'
		},
	},
	setup(props) {
		// console.log('props.feature', props.feature)
		// if (!props.feature) {
		// 	console.log('AAAAAAAA', props.feature)
		// }

		const SVG = computed(() => {
			const feature = props.feature.geometry ? props.feature.geometry : { type: 'Feature', geometry: props.feature }
			// console.log('feature', feature)

			// console.log('length', feature.geometry.coordinates.length)
			if (!props.feature || feature.geometry.coordinates.length < 1 || feature.geometry.coordinates[0].length < 1) {
				// console.log('feature.geometry.coordinates.length < 1', feature.geometry.coordinates)
				return null
			}

			return geoJson2SVG(feature, {
				stroke: props.strokeColor,
				fill: props.fillColor,
			})
		})

		return {
			SVG
		}
	}
}
</script>
<style lang="scss">
.geometry-svg {
	// & > svg {
	// 	max-height: 200px;
	// 	margin: 0 auto;
	// 	display: block;
	// }

	// padding: 7px;
	position: relative;
	min-height: 215px;

	& > svg {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate3d(-50%, -50%, 0);
		max-height: 200px;
		height: 100%;
		max-width: 100%;
	}
}
</style>
